/* eslint-disable no-restricted-globals */
import React, { Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { makeStyles } from '@mui/styles';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
// Import images
import image1 from 'assets/images/idleScreen/1.jpg';
import image2 from 'assets/images/idleScreen/2.jpg';
import image3 from 'assets/images/idleScreen/3.jpg';
import image4 from 'assets/images/idleScreen/4.png';
import image5 from 'assets/images/idleScreen/5.jpg';



const useStyles = makeStyles((theme) => {
    return {
        swiper: {
            height: '100vh', // Ensures Swiper spans the full height
            width: '100%', // Ensures Swiper spans the full width
        },
        swiperSlide: {
            height: '100vh', // Ensures each slide spans the full height
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#275ff0'
        },
        image: {
            width: 'auto', // Full width of the slide
            height: '100vh', // Full height of the slide
            objectFit: 'cover', // Maintain aspect ratio and cover the container
        },
    };
});

const IdleSwiper = ({ handleTouch }) => {
    const classes = useStyles();
    const images = [image1, image2, image3, image4, image5]; // Use imported images

    return (
        <Fragment>
            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                navigation={true}
                pagination={{
                    clickable: true,
                  }}
                centeredSlides={true}
                onSwiper={(swiper) => (window.swiper = swiper)}
                className={classes.swiper}
                autoplay={{ disableOnInteraction: false, waitForTransition: false, delay: 15000 }}
                slidesPerView={1}
                loop={true}
                onClick={handleTouch}
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index} className={classes.swiperSlide}>
                        <img src={image} alt={`Slide ${index + 1}`} className={classes.image} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Fragment>
    );
};

export default IdleSwiper;


